(function () {
  function initFeaturedCollection(section) {
    const slider = section.querySelector('[class*="featured-collection-slider-"]');
    if (!slider) return;
    if (slider.swiper) {
      slider.swiper.destroy(true, true);
    }
    const nextBtn = section.querySelector('[class*="collection-nav-next-"]');
    const prevBtn = section.querySelector('[class*="collection-nav-prev-"]');
    const desktopColumns =
      parseInt(section.dataset.desktopColumns) || 4;
    // Check if section has inline-arrows class
    const mobileSlides = 2.89;
    new Swiper(slider, {
      speed: 500,
      loop: true,
      observer: true,
      observeParents: true,
      watchOverflow: true,
      watchSlidesProgress: true,
      spaceBetween: 0,
      slidesPerView: mobileSlides,
      navigation: {
        nextEl: nextBtn,
        prevEl: prevBtn
      },
      breakpoints: {
        768: {
          slidesPerView: desktopColumns,
          spaceBetween: 0
        }
      }
    });
  }

  function initAll() {
    document
      .querySelectorAll('.featured-collection-section')
      .forEach(initFeaturedCollection);
  }

  document.addEventListener('DOMContentLoaded', initAll);

  document.addEventListener('shopify:section:load', function (e) {
    initFeaturedCollection(e.target);
  });

})();